import * as React from 'react';
import {DataGrid} from "@mui/x-data-grid";
import {Box, CircularProgress, Typography} from "@mui/material";
import {useGetEmployeeBalanceQuery} from "../../core/api/balance-api";
import {useSelector} from "react-redux";
import {format} from "date-fns";
import "./Balance.css"
import PropTypes from "prop-types";
import {getDateInServerTimeZone} from "../../core/utils/utils";

const columns = [
    {field: 'id', headerName: 'id', hide: true},
    {field: 'ind', headerName: 'ID', width: 50},
    {
        field: 'createdAt', headerName: 'Date', width: 100,
        renderCell: (params) =>
            <div>{format(getDateInServerTimeZone(params.row.createdAt), "dd.MM.yyyy")}</div>
    },
    {
        field: 'sum', headerName: 'Accrual/Deduction', width: 200,
        renderCell: (params) => {
            if (params.row.sum > 0) {
                return <div className={"balance-accrual"}>+{params.row.sum}</div>;
            }
            return params.row.sum;
        }
    },
    {field: 'comment', headerName: 'Comment', width: 400},
    {field: 'authorName', headerName: 'Author', width: 400},

];
export default function Balance(props) {
    const sessionState = useSelector((state) => state.data.UserSession)
    let employeeEmail;
    let isAdminMode = false;
    if (props.employeeEmail) {
        isAdminMode = true;
        employeeEmail = props.employeeEmail;
    } else {
        employeeEmail = sessionState.authenticated ? sessionState.user.username : ''
    }
    const {data: balanceHistory = [], isFetching} = useGetEmployeeBalanceQuery({
        isAdminMode: isAdminMode,
        employeeEmail: employeeEmail
    })

    const getNameFromEmail = (email) => {
        if (email) {
            const nameEndIndex = email.indexOf('@');
            return email.substring(0, nameEndIndex).replace('_', ' ').toUpperCase();
        }
        return "";
    }

    return (
        <Box className='page-main-box' sx={{ px: { xs: 1, sm: 2 }, py: { xs: 1, sm: 2 } }}>
            {isFetching ?
                <Box sx={{display: 'flex'}}>
                    <CircularProgress/>
                </Box> :
                <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0 }}>
                    <Typography gutterBottom variant="body1" component="h3">
                        Accrual history {getNameFromEmail(props.employeeEmail)}
                    </Typography>
                    <Box sx={{ width: '100%', height: 600, overflowX: 'auto' }}>
                        <DataGrid
                            sx={{ m: 0, minWidth: 600 }}
                            rows={balanceHistory}
                            columns={columns}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                        />
                    </Box>
                </Box>
            }
        </Box>

    );
}

Balance.propTypes = {
    employeeEmail: PropTypes.string,
}